<template>
  <div class="bgxq_main">
    <div class="top_container">
      <div class="top_title">
        <span>{{ bgcsTKName }}变更</span>
      </div>
      <div class="form_container">
        <el-form disabled>
          <!-- 变更数量 -->
          <el-form-item
            v-if="bgSl.isChange"
            :label="ywlxSl + '(变更前)：'"
            label-width="140px"
          >
            <el-input v-model="bgSl.beforeValue" disabled />
          </el-form-item>
          <el-form-item
            v-if="bgSl.isChange"
            :label="ywlxSl + '(变更后)：'"
            label-width="140px"
          >
            <el-input v-model="bgSl.afterValue" disabled />
          </el-form-item>
          <!-- 抵达数量 运输报备 -->
          <el-form-item
            v-if="ddsl.isChange"
            label="抵达数量(变更前)："
            label-width="140px"
          >
            <el-input v-model="ddsl.beforeValue" disabled />
          </el-form-item>
          <el-form-item
            v-if="ddsl.isChange"
            label="抵达数量(变更后)："
            label-width="140px"
          >
            <el-input v-model="ddsl.afterValue" disabled />
          </el-form-item>

          <!-- 变更仓库 -->
          <el-form-item
            v-if="bgCkid.isChange"
            :label="
              xqType == 'ykbb' ? '移出仓库(变更前)：' : '存放仓库(变更前)：'
            "
            label-width="140px"
          >
            <el-input v-model="bgCkid.beforeValue" disabled />
          </el-form-item>
          <el-form-item
            v-if="bgCkid.isChange"
            :label="
              xqType == 'ykbb' ? '移出仓库(变更后)：' : '存放仓库(变更后)：'
            "
            label-width="140px"
          >
            <el-input v-model="bgCkid.afterValue" disabled />
          </el-form-item>

          <!-- 变更仓库id2  移库报备 -->
          <el-form-item
            v-if="bgCkid2.isChange"
            label="移入仓库(变更前)："
            label-width="140px"
          >
            <el-input v-model="bgCkid2.beforeValue" disabled />
          </el-form-item>
          <el-form-item
            v-if="bgCkid2.isChange"
            label="移入仓库(变更后)："
            label-width="140px"
          >
            <el-input v-model="bgCkid2.afterValue" disabled />
          </el-form-item>

          <!-- 变更委托单位 -->
          <el-form-item
            v-if="bgWtmc.isChange"
            label="委托单位(变更前)："
            label-width="140px"
          >
            <el-input v-model="bgWtmc.beforeValue" disabled />
          </el-form-item>
          <el-form-item
            v-if="bgWtmc.isChange"
            label="委托单位(变更后)："
            label-width="140px"
          >
            <el-input v-model="bgWtmc.afterValue" disabled />
          </el-form-item>

          <!-- 变更起运数量 -->
          <el-form-item
            v-if="bgQysl.isChange"
            label="起运数量(变更前)："
            label-width="140px"
          >
            <el-input v-model="bgQysl.beforeValue" disabled />
          </el-form-item>
          <el-form-item
            v-if="bgQysl.isChange"
            label="起运数量(变更后)："
            label-width="140px"
          >
            <el-input v-model="bgQysl.afterValue" disabled />
          </el-form-item>

          <!-- 变更入库日期 -->
          <el-form-item
            v-if="bgSj.isChange"
            :label="ywlxRq + '(变更前)：'"
            label-width="140px"
          >
            <el-input v-model="bgSj.beforeValue" disabled />
          </el-form-item>
          <el-form-item
            v-if="bgSj.isChange"
            :label="ywlxRq + '(变更后)：'"
            label-width="140px"
          >
            <el-input v-model="bgSj.afterValue" disabled />
          </el-form-item>

          <!-- 变更理由 -->
          <el-form-item
            style="width: 97%; margin-right: 0"
            label="变更理由："
            label-width="140px"
          >
            <el-input v-model="form_config.bgly" disabled />
          </el-form-item>
          <!-- 变更内容 -->
          <!-- <el-form-item
            style="width: 97%; margin-right: 0"
            label="变更内容："
            label-width="140px"
          >
            <el-input disabled v-model="form_config.bgnr"></el-input>
          </el-form-item> -->
        </el-form>
      </div>
    </div>
    <div class="bottom_container">
      <div class="bottom_title">
        <span>变更审批</span>
      </div>
      <div class="main_lc">
        <el-timeline>
          <!-- v-if="dataobj['sphjDtoList'][0]" -->
          <el-timeline-item v-if="dataobj[0]" icon="el-icon-time" size="large">
            <div style="margin-top: 2px">
              <span style="font-weight: bold">申请时间：</span><span>{{ dataobj[0].clsj }}</span>
            </div>
          </el-timeline-item>
          <el-timeline-item
            v-for="(item, index) in dataobj"
            :key="index"
            :icon="item.icon"
            :type="item.type"
            :size="item.size"
          >
            <div style="display: flex; align-items: center; flex-wrap: wrap">
              <div style="margin-right: 20px">
                <span style="font-weight: bold">审批单位：</span>{{ item.dqbmLabel }}
              </div>
              <div v-if="item.sftyLabel != '待审批'" style="margin-right: 20px">
                <span style="font-weight: bold">{{ item.jsLabel }}人：</span>{{ item.sjsprLabel }}
              </div>
              <div style="margin-right: 20px">
                <span style="font-weight: bold">审批结果：</span><span :style="'color: ' + item.color">{{
                  item.sftyLabel
                }}</span>
              </div>
              <div v-if="item.sftyLabel != '待审批'" style="margin-right: 20px">
                <span style="font-weight: bold">审批时间：</span>{{ item.spsj }}
              </div>
            </div>
            <div v-if="item.sftyLabel != '待审批'" style="margin-top: 2px">
              <span style="font-weight: bold">审批意见：</span><span>{{ item.spyj }}</span>
            </div>
          </el-timeline-item>
        </el-timeline>
      </div>
    </div>
  </div>
</template>

<script>
import { crkbgXqData, ykbbbgXqData, ysbbbgXqData } from '../../assets/js/bgcrk'
export default {
  name: 'BgxqCom',
  props: ['bgcsTKName', 'dgcsXqId', 'xqType'],
  data() {
    return {
      dataobj: [],
      titlename: [],
      slLabel: '出库数量(变更前)',
      form_config: {},

      // 数量是否变更
      bgSl: {
        afterValue: '',
        beforeValue: '',
        isChange: false
      },
      // 抵达数量是否变更  运输报备
      ddsl: {
        afterValue: '',
        beforeValue: '',
        isChange: false
      },
      // 仓库是否变更
      bgCkid: {
        afterValue: '',
        beforeValue: '',
        isChange: false
      },
      // 仓库2是否变更  移库报备
      bgCkid2: {
        afterValue: '',
        beforeValue: '',
        isChange: false
      },
      // 委托单位是否变更
      bgWtmc: {
        afterValue: '',
        beforeValue: '',
        isChange: false
      },
      // 起运数量是否变革
      bgQysl: {
        afterValue: '',
        beforeValue: '',
        isChange: false
      },
      // 入库日期是否变革
      bgSj: {
        afterValue: '',
        beforeValue: '',
        isChange: false
      },

      ywlxSl: null,
      ywlxRq: null
    }
  },
  mounted() {
    // this.getsphjMess();
    var crkname =
      this.xqType == 'ykbb'
        ? ykbbbgXqData
        : this.xqType == 'ysbb'
          ? ysbbbgXqData
          : crkbgXqData
    crkname(this.dgcsXqId).then((res) => {
      this.dataobj = res.data.data.sphjDtoList
      this.form_config = res.data.data.dbspCrkBgjlDto
      if (this.dataobj) {
        this.dataobj.forEach((hj, index) => {
          if (index == this.dataobj.length - 1 || this.dataobj.length == 1) {
            hj.icon = 'el-icon-success'
            hj.type = 'success'
            hj.size = 'large'
          }
        })
      }
      if (this.dataobj) {
        this.dataobj.forEach((item) => {
          if (item.sftyLabel == '待审批') {
            item.color = 'Orange'
          } else if (item.sftyLabel == '同意') {
            item.color = '#00ceb7'
          } else if (item.sftyLabel == '不同意') {
            item.color = 'red'
          }
        })
      }

      // 数量
      if (this.form_config.bgSl) {
        this.bgSl.afterValue =
          this.form_config.bgSl.afterValue +
          this.form_config.bgSldwLabel.afterValue
        this.bgSl.beforeValue =
          this.form_config.bgSl.beforeValue +
          this.form_config.bgSldwLabel.beforeValue
        this.bgSl.isChange = this.form_config.bgSl.isChange
      }
      // 抵达数量 运输报备
      if (this.form_config.ddsl) {
        this.ddsl.afterValue =
          this.form_config.ddsl.afterValue +
          this.form_config.ddsldwLabel.afterValue
        this.ddsl.beforeValue =
          this.form_config.ddsl.beforeValue +
          this.form_config.ddsldwLabel.beforeValue
        this.ddsl.isChange = this.form_config.ddsl.isChange
      }

      // 仓库
      if (this.form_config.bgCkid) {
        this.bgCkid.afterValue = this.form_config.bgCkid.afterValue
        this.bgCkid.beforeValue = this.form_config.bgCkid.beforeValue
        this.bgCkid.isChange = this.form_config.bgCkid.isChange
      }
      // 仓库2移库报备
      if (this.form_config.bgCkid2) {
        this.bgCkid2.afterValue = this.form_config.bgCkid2.afterValue
        this.bgCkid2.beforeValue = this.form_config.bgCkid2.beforeValue
        this.bgCkid2.isChange = this.form_config.bgCkid2.isChange
      }

      // 委托单位
      if (this.form_config.bgWtmc) {
        this.bgWtmc.afterValue = this.form_config.bgWtmc.afterValue
        this.bgWtmc.beforeValue = this.form_config.bgWtmc.beforeValue
        this.bgWtmc.isChange = this.form_config.bgWtmc.isChange
      }

      // 起运数量]
      if (this.form_config.bgQySl) {
        this.bgQysl.afterValue =
          this.form_config.bgQySl.afterValue +
          this.form_config.bgQySldwLabel.afterValue
        this.bgQysl.beforeValue =
          this.form_config.bgQySl.beforeValue +
          this.form_config.bgQySldwLabel.beforeValue
        this.bgQysl.isChange = this.form_config.bgQySl.isChange
      }

      // 入库日期
      if (this.form_config.bgSj) {
        this.bgSj.afterValue = this.form_config.bgSj.afterValue
        this.bgSj.beforeValue = this.form_config.bgSj.beforeValue
        this.bgSj.isChange = this.form_config.bgSj.isChange
      }

      // 业务类型
      // 移库报备
      if (this.xqType == 'ykbb') {
        this.ywlxSl = '移库数量'
        this.ywlxRq = '移库日期'
      }
      // 运输报备
      if (this.xqType == 'ysbb') {
        this.ywlxSl = '起运数量'
        this.ywlxRq = '运输日期'
      }

      // 生产入库
      if (this.form_config.ywlx == 0) {
        this.ywlxSl = '入库数量'
        this.ywlxRq = '生产日期'
      }
      // 购买入库
      else if (this.form_config.ywlx == 1) {
        this.ywlxSl = '入库数量'
        this.ywlxRq = '入库日期'
      }
      // 其他入库
      else if (this.form_config.ywlx == 2) {
        this.ywlxSl = '入库数量'
        this.ywlxRq = '入库日期'
      }
      // 使用出库
      else if (this.form_config.ywlx == 3) {
        this.ywlxSl = '出库数量'
        this.ywlxRq = '领用日期'
      }
      // 销售出库
      else if (this.form_config.ywlx == 4) {
        this.ywlxSl = '出库数量'
        this.ywlxRq = '出库日期'
      }
      // 其他出库
      else if (this.form_config.ywlx == 5) {
        this.ywlxSl = '出库数量'
        this.ywlxRq = '出库日期'
      }
      // 增溢入库
      else if (this.form_config.ywlx == 7) {
        this.ywlxSl = '增溢数量'
        this.ywlxRq = '入库日期'
      }
      // 损耗出库
      else if (this.form_config.ywlx == 8) {
        this.ywlxSl = '损耗数量'
        this.ywlxRq = '出库日期'
      }
      // 退货入库
      else if (this.form_config.ywlx == 9) {
        this.ywlxSl = '入库数量'
        this.ywlxRq = '入库日期'
      }
      // 退货出库
      else if (this.form_config.ywlx == 10) {
        this.ywlxSl = '退货数量'
        this.ywlxRq = '退货日期'
      }
      // 仓储出库
      else if (this.form_config.ywlx == 11) {
        this.ywlxSl = '出库数量'
        this.ywlxRq = '出库日期'
      }
      // 仓储入库
      else if (this.form_config.ywlx == 12) {
        this.ywlxSl = '入库数量'
        this.ywlxRq = '入库日期'
      }
      //  仓储报备（即仓储损溢）
      else if (this.form_config.ywlx == 13) {
        this.ywlxSl = '报备数量'
        this.ywlxRq = '报备日期'
      }
      //  内部使用退回
      else if (this.form_config.ywlx == 21) {
        this.ywlxSl = '退回数量'
        this.ywlxRq = '退回日期'
      } else if (this.form_config.ywlx == 20) {
        this.ywlxSl = '调入数量'
        this.ywlxRq = '调入日期'
      } else if (this.form_config.ywlx == 24) {
        this.ywlxSl = '调出数量'
        this.ywlxRq = '调出日期'
      } else if (this.form_config.ywlx == 19) {
        this.ywlxSl = '进口数量'
        this.ywlxRq = '进口日期'
      } else if (this.form_config.ywlx == 23) {
        this.ywlxSl = '出口数量'
        this.ywlxRq = '出口日期'
      }
    })
  },
  methods: {
    getsphjMess() {
      const dataobj = {
        zssq: [
          {
            hjsx: 1,
            dwjbLabel: '禁毒大队',
            dqbmLabel: '肇庆市公安局鼎湖分局禁毒大队',
            sjsprLabel: '黎福泉',
            spsj: '2022-01-07 16:07:12',
            sfty: '1',
            sftyLabel: '同意',
            spyj: '',
            clsj: '2022-01-07 16:04:45',
            ywlx: '21',
            js: '104',
            jsLabel: '受理',
            ywlxLabel: '购买证申请'
          },
          {
            hjsx: 2,
            dwjbLabel: '禁毒大队',
            dqbmLabel: '肇庆市公安局鼎湖分局禁毒大队',
            sjsprLabel: '黎福泉',
            spsj: '2022-01-07 16:07:18',
            sfty: '1',
            sftyLabel: '同意',
            spyj: '',
            clsj: '2022-01-07 16:04:45',
            ywlx: '21',
            js: '103',
            jsLabel: '审核',
            ywlxLabel: '购买证申请'
          },
          {
            hjsx: 3,
            dwjbLabel: '禁毒大队',
            dqbmLabel: '肇庆市公安局鼎湖分局禁毒大队',
            sjsprLabel: '陈肇勇',
            spsj: '2022-01-07 16:07:54',
            sfty: '1',
            sftyLabel: '同意',
            spyj: '',
            clsj: '2022-01-07 16:04:45',
            ywlx: '21',
            js: '102',
            jsLabel: '审批',
            ywlxLabel: '购买证申请'
          }
        ],
        zsqxhx: [
          [
            {
              hjsx: 1,
              dwjbLabel: '禁毒大队',
              dqbmLabel: '鼎湖区',
              sftyLabel: '待审批',
              clsj: '2022-01-09 17:01:14',
              ywlx: '25',
              information: '文件资料出错',
              js: '103',
              jsLabel: '审核',
              ywlxLabel: '购买证取消核销'
            }
          ],
          [
            {
              hjsx: 1,
              dwjbLabel: '禁毒大队',
              dqbmLabel: '肇庆市公安局鼎湖分局禁毒大队',
              sjsprLabel: '黎福泉',
              spsj: '2022-01-08 16:55:10',
              sfty: '0',
              sftyLabel: '不同意',
              spyj: '资料不足',
              clsj: '2022-01-07 17:32:28',
              ywlx: '25',
              information: '按错了',
              js: '103',
              jsLabel: '审核',
              ywlxLabel: '购买证取消核销'
            },
            {
              hjsx: 2,
              dwjbLabel: '禁毒大队',
              dqbmLabel: '肇庆市公安局鼎湖分局禁毒大队',
              sjsprLabel: '黎福泉',
              spsj: '2022-01-08 16:55:10',
              sfty: '0',
              sftyLabel: '不同意',
              spyj: '资料不足',
              clsj: '2022-01-07 17:32:28',
              ywlx: '25',
              information: '按错了',
              js: '103',
              jsLabel: '审核',
              ywlxLabel: '购买证取消核销'
            }
          ]
        ]
      }
      for (var key of Object.keys(dataobj)) {
        dataobj[key].forEach((hj, index) => {
          if (index == 0) {
            hj.icon = 'el-icon-time'
            hj.type = 'warning'
            hj.size = 'large'
          }
          if (index == dataobj.zssq.length - 1 || dataobj.zssq.length == 1) {
            hj.icon = 'el-icon-success'
            hj.type = 'success'
            hj.size = 'large'
          }
        })
        this.titlename.push(key)
      }
      this.dataobj = dataobj
    }
  }
}
</script>

<style lang="less" scoped>
.bgxq_main {
  //height: 400px;
  height: 100%;
  padding: 0 50px;
  .top_container {
    height: 100%;
    width: 100%;
    .top_title {
      height: 15px;
      width: 160px;
      color: #000;
      line-height: 15px;
      font-size: 16px;
      border-left: 5px solid #ffb50d;
      font-weight: 700;
      text-align: left;
      padding-left: 20px;
      span {
        width: 80px;
        margin: 15px 0 0 0px;
      }
    }
    .form_container {
      height: 100%;
      margin-top: 50px;
      .el-form {
        display: flex;
        flex-wrap: wrap;
      }
      .el-form-item {
        width: 47%;
        margin-right: 3%;
        &:nth-child(2n) {
          margin-right: 0%;
        }
      }
      /deep/.el-form-item__label {
        line-height: 40px;
      }
    }
  }
  .bottom_container {
    margin-top: 50px;
    .bottom_title {
      height: 15px;
      width: 100px;
      color: #000;
      line-height: 15px;
      font-size: 16px;
      border-left: 5px solid #d03ee9;
      font-weight: 700;
      text-align: center;
      span {
        width: 80px;
        margin: 15px 0 0 15px;
      }
    }
    .main_lc {
      margin-top: 50px;
      //height: 400px;
      // background-color: darksalmon;
    }
  }
  /deep/.el-timeline {
    padding-left: 0;
  }
  /deep/.el-timeline-item__icon {
    font-size: 16px !important;
    color: #fff;
    background-color: #ef9a12;
    border-radius: 50%;
  }

  /deep/.el-icon-success {
    color: #6acd18;
    background-color: #fff;
  }
}
</style>
